import { Camera as CameraIcon, Cameraswitch as CameraswitchIcon, Close as CloseIcon } from '@mui/icons-material';
import proptypes from 'prop-types';
import Webcam from 'react-webcam';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';

function Camera({ onCapture, imagefield }) {
  const webcamRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isFrontCamera = useSelector((state) => state.camera.frontCamera);
  const [videoDevices, setVideoDevices] = useState([]);

  useEffect(() => {
    enumerateDevicesForScan();
  }, []);

  async function enumerateDevicesForScan() {
    if (navigator?.mediaDevices?.enumerateDevices()) {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const tmpVideoDevices = devices.filter((device) => device.kind === 'videoinput');
      setVideoDevices(tmpVideoDevices);
    }
  }

  const videoConstraints = {
    width: 640,
    height: 480,
    deviceId: isFrontCamera ? videoDevices[videoDevices.length - 1]?.deviceId : videoDevices[0]?.deviceId,
  };

  const capture = () => {
    const tmpImageSrc = webcamRef.current.getScreenshot();
    const byteCharacters = atob(tmpImageSrc.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const file = new File([byteArray], `${imagefield}.jpg`, { type: 'image/jpeg' });
    onCapture(file);
  };

  const handleClose = () => {
    dispatch({ type: 'camera/stop' });
  };

  const handleSwitch = () => {
    dispatch({ type: 'camera/stop' });
    dispatch({ type: 'camera/switchCamera' });
    dispatch({ type: 'camera/start' });
  };

  return (
    <div id="modalOverlayCamera">
      <Container maxWidth="lg">
        <div id="cameraHeader">
          <div id="cameraHeaderTitle">{t('common.camera.title')}</div>
          <Container sx={{ display: 'inline-flex', justifyContent: 'end', p: 0, m: 0, width: '50%' }}>
            <div onClick={handleSwitch} onKeyPress={handleSwitch} tabIndex={0} role="button" type="button" id="cameraOverlaySwitch" className="cameraOverlayIcon">
              <CameraswitchIcon />
            </div>
            <div onClick={handleClose} onKeyPress={handleClose} tabIndex={0} role="button" type="button" id="cameraOverlayClose" className="cameraOverlayIcon">
              <CloseIcon />
            </div>
          </Container>
        </div>
        <Webcam audio={false} height="613em" width="80%" ref={webcamRef} screenshotFormat="image/jpeg" videoConstraints={videoConstraints} />
        <div onClick={capture} onKeyPress={capture} tabIndex={0} role="button" type="button" id="cameraOverlayCapture" className="cameraOverlayIcon">
          <CameraIcon />
        </div>
      </Container>
    </div>
  );
}

Camera.propTypes = {
  onCapture: proptypes.func.isRequired,
  imagefield: proptypes.string.isRequired,
};

export default Camera;
